import styled from 'styled-components';
export const ScrollContainer = styled.div.withConfig({ displayName: "vui--ScrollContainer", componentId: "vui--1ruib9d" }) `position:relative;width:100%;overflow-x:auto;overflow-y:hidden;`;
//# sourceMappingURL=ScrollContainer.js.map